import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
var Common = {
  echarts: [],
  isMobile: false,
  getQueryString: function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg); // 获取url中"?"符后的字符串并正则匹配

    var context = '';

    if (r != null) {
      context = decodeURIComponent(r[2]);
    }

    reg = null;
    r = null;
    return context == null || context == '' || context == 'undefined' ? '' : context;
  },
  delQueryString: function delQueryString(name) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + '?';
    var query = loca.search.substr(1);

    if (query.indexOf(name) > -1) {
      var obj = {};
      var arr = query.split('&');

      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split('=');
        obj[arr[i][0]] = arr[i][1];
      }

      delete obj[name];
      var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&');
      return url;
    } else {
      return window.location.href;
    }
  },
  formatMoney: function formatMoney(obj) {
    if (!obj) {
      return obj;
    }

    obj = obj + '';
    obj = obj.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符

    obj = obj.replace(/\.{2,}/g, ".").replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留第一个. 清除多余的

    obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数

    if (obj.indexOf(".") < 0 && obj != "") {
      //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
      obj = parseFloat(obj);
    }

    return obj;
  }
};
export { Common };